// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"270":"0df04a54","383":"24769981","888":"4086858e","947":"cc57d237"}[chunkId] + ".chunk.css";
};